// initial state for book slice declared here
const initialState = {
    bookList: [],
    editBook: {},
};

export default initialState;